import React from 'react';
import { useAuth } from '@/lib/AuthContext';
import UserNotRegisteredError from '@/components/UserNotRegisteredError';
import Onboarding from '@/pages/Onboarding';

/**
 * RootGate - Point d'entree unique de l'application
 *
 * Gere la logique d'authentification et d'onboarding avant d'afficher l'app principale.
 * La Map n'est JAMAIS accessible sans:
 * - Authentification valide
 * - Onboarding complete (onboarding_completed === true)
 * - Statut ACTIVE (access_status === 'ACTIVE')
 */
export default function RootGate({ children }) {
  const {
    user,
    isAuthenticated,
    isLoadingAuth,
    isLoadingPublicSettings,
    authError
  } = useAuth();

  // 1. Loading - Afficher spinner pendant la verification
  if (isLoadingPublicSettings || isLoadingAuth) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-[#0A0B10]">
        <div className="w-8 h-8 border-4 border-[#6E2BFF] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // 2. Erreur user_not_registered
  if (authError?.type === 'user_not_registered') {
    return <UserNotRegisteredError />;
  }

  // 3. Non authentifie -> Onboarding
  if (!isAuthenticated || authError?.type === 'auth_required') {
    return <Onboarding />;
  }

  // 4. Profil pas encore enrichi (fetchProfile en cours) -> spinner
  if (isAuthenticated && user && !('onboarding_completed' in user)) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-[#0A0B10]">
        <div className="w-8 h-8 border-4 border-[#6E2BFF] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // 5. Authentifie mais onboarding incomplet ou pas ACTIVE -> Continuer onboarding
  if (!user?.onboarding_completed || user?.access_status !== 'ACTIVE') {
    return <Onboarding />;
  }

  // 5. Tout est OK -> Afficher l'application principale
  return children;
}
